import { createSlice } from '@reduxjs/toolkit'
import type { LeaderboardEntry } from 'api/types'
import { RootState } from 'store'
import { deleteUserChallenge, getChallengeLeaderboard } from './thunks'

interface LeaderboardState {
  leaderboard: LeaderboardEntry[]
  status: RequestStatus
  error: string | null
}

const leaderboard: LeaderboardState = {
  leaderboard: [],
  status: 'idle',
  error: null,
}

const leaderboardSlice = createSlice({
  name: 'leaderboard',
  initialState: leaderboard,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getChallengeLeaderboard.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(getChallengeLeaderboard.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getChallengeLeaderboard.fulfilled, (state, action) => {
        state.status = 'succeeded'
        if (action.payload.data && action.payload.data.length > 0) {
          state.leaderboard = action.payload.data
        } else if (action.payload.data?.length === 0) {
          state.leaderboard = []
        }
      })

    builder
      .addCase(deleteUserChallenge.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(deleteUserChallenge.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(deleteUserChallenge.fulfilled, (state) => {
        state.status = 'succeeded'
      })
  },
})

export default leaderboardSlice.reducer

export const selectLeaderboard = (state: RootState) => state.leaderboard
